// Bibliotecas
import React, { useEffect, useRef, useState } from 'react';
import { Col, Row, Card, CardText, Form, CardBody } from 'reactstrap';
import Dropzone from 'react-dropzone';
import SweetAlert from 'react-bootstrap-sweetalert';
import readXlsxFile from 'read-excel-file';

// Assets
import ModeloUpload from '../../../assets/statics/modelo_grupos_participante.xlsx';

// Services
import { createLoginGroup } from '../../../utils/services/logingroup';

// Utils
import { formatBytes } from '../../../utils/helpers/files/formatBytes';
import {
  allExcelColumns,
  excelColumnsPtBr,
  findRowsWithError,
} from './importGroupsValidation';

// Componentes
import ModalExcelRows from '../Voo/ModalExcelRows';

const XLSX_SCHEMA = {
  email: { prop: 'email', type: String },
  grupo: { prop: 'group', type: String },
};

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

export default function ImportGroup(props) {
  const { isOpen, toggle, active, idEvent, token } = props;

  // state de arquivos
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [imgError, setImgError] = useState('');

  // state de progresso
  const [totalRows, setTotalRows] = useState(0);
  const [totalSended, setTotalSended] = useState(0);
  const [btnSend, setBtnSend] = useState(false);
  const [btnCancel, setBtnCancel] = useState(false);

  // state de modais
  const [successDlg, setSuccessDlg] = useState(false);
  const [modalErrors, setModalErrors] = useState(false);
  const [errors, setErrors] = useState([]);

  const importActivated = useRef(false);

  useEffect(() => {
    setSelectedFiles([]);
    setImgError('');
  }, [isOpen]);

  // Atualiza o arquivo selecionado e reseta o progresso
  function handleAcceptedFiles(files) {
    files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    );
    setSelectedFiles(files);
    setTotalRows(0);
    setTotalSended(0);
    setBtnSend(true);
  }

  // Cancela o processo de importação em andamento
  function cancelImport() {
    importActivated.current = false;
    active(importActivated.current);
    setSelectedFiles([]);
    setTotalRows(0);
    setTotalSended(0);
    setBtnSend(false);
    setBtnCancel(false);
  }

  // Lê o xlsx, valida as linhas e dispara as requisições sequencialmente
  async function uploadService() {
    importActivated.current = true;
    active(importActivated.current);
    setBtnSend(false);
    setBtnCancel(true);

    let count = 0;

    const { rows } = await readXlsxFile(selectedFiles[0], {
      schema: XLSX_SCHEMA,
    });
    const validateRows = rows.map((row, i) => allExcelColumns(row, i));

    const [rowsWithError, validRows] = await findRowsWithError(
      validateRows,
      token,
      idEvent
    );
    setTotalRows(validRows.length);

    if (rowsWithError.length > 0 || rows.length === 0) {
      setErrors(rowsWithError);
      importActivated.current = false;
      active(importActivated.current);
      setModalErrors(true);
      return;
    }

    let i = 0;
    for (const row of validRows) {
      await sleep(100);
      if (!importActivated.current) break;
      await importLoginGroup(row, i, validRows.length);
      i++;
    }

    // Envia um grupo para a API e atualiza o progresso
    async function importLoginGroup(row, index, total) {
      try {
        const result = await createLoginGroup(
          {
            email: row.email,
            groups: row?.group.includes(',') ? row.group.split(',') : row?.group,
            eventId: idEvent,
          },
          token
        );

        if (result.message === 'SENDED_TO_QUEUE') {
          setTotalSended(++count);
        }
        if (total === ++index) {
          setBtnCancel(false);
        }
        if (count === total) {
          setSuccessDlg(true);
          props.getAllParticipants();
        }
      } catch (error) {
        console.error('Erro ao importar grupo:', error);
      }
    }
  }

  return (
    <div>
      {successDlg && (
        <SweetAlert
          success
          title={'Upload'}
          onConfirm={() => {
            props.getAllParticipants();
            setSuccessDlg(false);
            importActivated.current = false;
            active(importActivated.current);
            toggle();
          }}
        >
          {'O arquivo foi enviado com sucesso!'}
        </SweetAlert>
      )}
      {modalErrors && (
        <ModalExcelRows
          toggle={() => setModalErrors(false)}
          rows={errors.sort((a, b) => a.index - b.index)}
          columnNames={excelColumnsPtBr}
        />
      )}
      <div className="m-1 p-0">
        <Card className="p-1">
          <CardBody className="m-1 p-2">
            <CardText className="mb-2 p-10">
              O arquivo a ser importado deve seguir este{' '}
              <a href={ModeloUpload} download="modelo_grupos_participantes.xlsx">
                Modelo
              </a>
              , não modifique seu cabeçalho.
            </CardText>

            <Form>
              {selectedFiles.length === 0 && (
                <Dropzone onDrop={(acceptedFiles) => handleAcceptedFiles(acceptedFiles)}>
                  {({ getRootProps, getInputProps }) => (
                    <div className="dropzone">
                      <div
                        className="dz-message needsclick mt-1"
                        {...getRootProps()}
                      >
                        <input {...getInputProps()} />
                        <div className="mb-4">
                          <i className="display-4 text-muted bx bxs-cloud-upload" />
                          <h4>Arraste o arquivo ou clique aqui e selecione.</h4>
                        </div>
                      </div>
                    </div>
                  )}
                </Dropzone>
              )}
              <div className="dropzone-previews mt-0" id="file-previews">
                {selectedFiles.map((f, i) => (
                  <Card
                    className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                    key={i + '-file'}
                  >
                    <div className="p-1">
                      <Row className="align-items-center">
                        <Col xs="11">
                          <strong>{`Nome: ${f.name} - Tamanho: ${f.formattedSize}`}</strong>
                        </Col>
                        <Col xs="1">
                          <span
                            style={{
                              fontSize: '16px',
                              color: 'red',
                              fontWeight: '700',
                              cursor: 'pointer',
                            }}
                            className="mdi mdi-close"
                            onClick={() => {
                              setSelectedFiles([]);
                              setBtnSend(false);
                            }}
                          />
                        </Col>
                      </Row>
                      {importActivated.current && (
                        <Row className="align-items-center">
                          <Col>
                            <strong>{`Total enviado: ${totalSended}/${totalRows}`}</strong>
                          </Col>
                        </Row>
                      )}
                    </div>
                  </Card>
                ))}
              </div>
            </Form>

            <div className="text-center mt-3">
              <p style={{ color: 'red' }}>{imgError}</p>
              <button
                type="button"
                className="btn btn-primary waves-effect waves-light"
                disabled={!btnSend}
                onClick={() => uploadService()}
              >
                Enviar Grupos
              </button>
              <button
                type="button"
                className="btn btn-danger mx-1"
                disabled={!btnCancel}
                onClick={() => cancelImport()}
              >
                Cancelar
              </button>
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
}
